import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as notificationsApi from '../../../api/notification';
import { NotificationContract } from '../../../types/Endpoints/notification/NotificationContract';

export const SET_READ_NOTIFICATIONS = 'notifications/setReadNotifications';

export const setReadNotifications = createAsyncThunk<NotificationContract['responseBody']>(
    SET_READ_NOTIFICATIONS,
    createRequest({
        type: SET_READ_NOTIFICATIONS,
        loader: () => notificationsApi.setReadNotifications(),
    }),
);
